import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M13.8897 10.9449V12.8051C13.8897 13.8793 13.019 14.75 11.9449 14.75C10.8707 14.75 10 13.8793 10 12.8051V10.9449C10 9.87074 10.8707 9 11.9449 9C13.019 9 13.8897 9.87074 13.8897 10.9449Z" />
		<Path d="M7.84999 15.5V12.525M7.84999 9.9V12.525M4.875 8.5V8.85L4 12.525H7.84999" />
		<Path d="M19.85 15.5V12.525M19.85 9.9V12.525M16.875 8.5V8.85L16 12.525H19.85" />
	</SVG>
);
